// removed by extract-text-webpack-plugin
module.exports = {"root":"_196DJ","img":"_2OJS2","placeholder":"_22Ywn","title":"_1aFlg","description":"_3oHOs","hideOnMobile":"N_n13"};